export const GetAllPOCompleted = async (data: any) => {
  const respone = await fetch("/api/Redcross/GetAllPOCompleted", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    });

  return respone;
};
